export const LEADERBOARD_ROWS_PER_PAGE = 10;

export const LEADERBOARD_ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
